'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUCCESS_VALUE = null;

function validateErrors(errors) {
  return !errors || errors.length === 0 ? SUCCESS_VALUE : 'error';
}

function validateUrl(val) {
  return val.match(/^https?:\/\/.+/) ? SUCCESS_VALUE : 'error';
}

function validateUrlOrEmpty(val) {
  if (!val) {
    return null;
  }

  return validateUrl(val);
}

function validate(type, value, errors) {
  switch (type) {
    case 'urlOrEmpty':
      return validateErrors(errors) || validateUrlOrEmpty(value);
    default:
      return SUCCESS_VALUE;
  }
}

exports.default = {
  validate: validate,
  validateErrors: validateErrors,
  validateUrl: validateUrl,
  validateUrlOrEmpty: validateUrlOrEmpty
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/validate.js
// module id = 527
// module chunks = 0